import React from 'react';
import './Roadmap.css';

const Roadmap: React.FC = () => {
  return (
    <div className="background-gradient">
      <section className="section">
        <div className="container roadmap-content">
        <div className="roadmap-content__intro">
          <p className="roadmap-content__text roadmap-content__text--lead">
            Celestix предлагает набор уникальных функций для студентов, обеспечивающих эффективное обучение, 
            коммуникацию и профессиональное развитие в закрытой экосистеме.
          </p>
        </div>

        <div className="roadmap-features">
          <div className="roadmap-feature card">
            <div className="roadmap-feature__icon">🎵</div>
            <h3 className="roadmap-feature__title">Глобальная музыка</h3>
            <p className="roadmap-feature__text">
              Интеграция Yamusic и VKMusic в единую платформу позволяет студентам получать доступ к обширной 
              музыкальной библиотеке из любого уголка мира, создавая комфортную атмосферу для учёбы и совместной работы.
            </p>
          </div>

          <div className="roadmap-feature card">
            <div className="roadmap-feature__icon">🌐</div>
            <h3 className="roadmap-feature__title">Пространства по интересам</h3>
            <p className="roadmap-feature__text">
              Пользователи могут создавать тематические пространства для проведения массовых созвонов. Функционал 
              включает демонстрацию экрана, виртуальную доску, виртуальные заметки и запись звонков с согласия всех 
              участников, что идеально подходит для групповых проектов и обсуждений.
            </p>
          </div>

          <div className="roadmap-feature card">
            <div className="roadmap-feature__icon">🔒</div>
            <h3 className="roadmap-feature__title">Безопасность и приватность</h3>
            <ul className="roadmap-feature__list">
              <li>Сквозное шифрование всех коммуникаций гарантирует конфиденциальность данных.</li>
              <li>Закрытое сообщество исключительно для студентов с работой в режиме белых списков обеспечивает 
              безопасность и контроль доступа.</li>
            </ul>
          </div>

          <div className="roadmap-feature card">
            <div className="roadmap-feature__icon">🚀</div>
            <h3 className="roadmap-feature__title">Поддержка проектов</h3>
            <p className="roadmap-feature__text">
              Платформа предоставляет участникам ресурсы (вычислительные мощности, инструменты, шаблоны) для 
              выполнения учебных задач и реализации проектов, ускоряя процесс разработки и исследования.
            </p>
          </div>

          <div className="roadmap-feature card">
            <div className="roadmap-feature__icon">📱</div>
            <h3 className="roadmap-feature__title">Мобильная аутентификация</h3>
            <p className="roadmap-feature__text">
              Разрабатывается мобильное приложение для двухфакторной аутентификации (по аналогии с Google Authenticator). 
              Полноценное приложение появится в зависимости от пользовательского спроса.
            </p>
          </div>

          <div className="roadmap-feature card">
            <div className="roadmap-feature__icon">🤝</div>
            <h3 className="roadmap-feature__title">Партнёрства и развитие</h3>
            <p className="roadmap-feature__text">
              Планируется сотрудничество с крупными проектами (например, через API от Сбера для ИИ-функций). 
              Список возможностей будет расширяться по мере доступности ресурсов и востребованности сообществом.
            </p>
          </div>
        </div>
        </div>
      </section>
    </div>
  );
};

export default Roadmap;
